/**
 * util to tell whether an element is visible in the window
 * @param element - element to test
 */
export const isInViewport = (element: Element): boolean => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

/**
 * Verify if the referrer is external
 * @param {*} referrer
 * @param {*} host
 * @returns
 */
export const isExternalReferrer = (referrer: string, host: string) =>
  referrer ? !referrer.split('//').pop().startsWith(host) : true;

export const navigateTo = (url: string) => {
  window.location.href = url;
};

/**
 * Conditionally navigate using Next.js router or window.location based on soft navigation flag
 * @param url - URL to navigate to
 * @param isAlpEnableSoftNavigation - Whether to use soft navigation (router.push) or hard navigation (window.location)
 * @param router - Next.js router instance from useRouter hook
 */
export const navigateToALPPage = (
  url: string,
  isAlpEnableSoftNavigation: boolean,
  router: { push: (url: string) => void }
) => {
  if (isAlpEnableSoftNavigation) {
    router.push(url);
  } else {
    navigateTo(url);
  }
};

export const isAndroidDevice = () => {
  if (typeof navigator !== 'undefined') {
    return navigator.userAgent.toLowerCase().includes('android');
  }
  return false;
};
